import {decompose} from './decompose'
import {rotatePoint} from './rotatePoint'

export const getRectCenter = (shape, stage) => {
  const transform = stage.getAbsoluteTransform().copy()
  transform.invert()
  const matrix = transform
    .multiply(shape.getAbsoluteTransform())
    .getMatrix()
  const newAttrs = {
    ...shape.getAttrs(),
    ...decompose(matrix)
  }

  const {
    x,
    y,
    width,
    height,
    scaleX = 1,
    scaleY = 1,
    rotation = 0
  } = newAttrs
  const uwidth = width * scaleX
  const uheight = height * scaleY
  const angle = Konva.getAngle(rotation)

  return rotatePoint(
    {x, y},
    {x: x + uwidth / 2, y: y + uheight / 2},
    angle
  )
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/getRectCenter.js